// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-controls[data-v-c23d9e38]{display:flex;justify-content:center}.editor-controls button[data-v-c23d9e38]:first-child{margin-left:0px}.editor-controls button[data-v-c23d9e38]:last-child{margin-right:0px}.editor-controls button path[data-v-c23d9e38]{fill:none;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;stroke:var(--ui-theme-icon)}\n", ""]);
// Exports
module.exports = exports;
